import { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

// terminals
import { getOrders } from "components/Apis/orders";
import { createPartial, deletePartials, modifyPartials } from "components/Apis/partials";

import { getActiveBusesNameList } from "components/Apis/Buses";
import { fetchTerminals } from "redux/warehouse/terminalSlice";
import { setShowReduxModal, updateWarehouseData } from "redux/warehouse/warehouseSlice";

export const PartialCreator = () => {
    const [order, setOrder] = useState(null)
    const [newRow, setNewRow] = useState({})

    const [buses, setBuses] = useState([])
    const [loading, setLoading] = useState(true)

    const updateBuses = (laneId) => {
        setLoading(true)
        try {
            getActiveBusesNameList(laneId)
                .then((response) => {
                    setBuses(response.data.buses)
                    setLoading(false)
                })
        }
        catch (error) {
            setLoading(false)
            console.error("Error fetching buses:", error);
        }
    }
    const dispatch = useDispatch()

    const { loading: terminalsLoading, terminals, error: terminalsError } = useSelector((state) => state.TerminalSlice);

    const warehouse = useSelector((state) => state.warehouse.warehouse)
    const modalState = useSelector((state) => state.warehouse.modalStates.partialCreator)

    const fetchOrder = async () => {
        setLoading(true)
        const orders = await getOrders(
            { id: modalState.orderId }
        )
        setOrder(orders[0])
        setLoading(false)
    }

    useEffect(() => {
        if (modalState.showModal) {
            fetchOrder()
        }
    }, [modalState])

    useEffect(() => {
        if (order) {
            updateBuses(order.terminal)
        }
    }, [order?.terminal])

    useEffect(() => {
        if (!terminals.length) {
            dispatch(fetchTerminals());
        }
    }, [dispatch]);

    const closeModal = () => {
        dispatch(
            setShowReduxModal(
                {
                    partialCreator: {
                        orderId: null,
                        showModal: false
                    }
                }
            )
        )
    }

    const handleChange = (e) => {
        setNewRow({ ...newRow, [e.target.name]: e.target.value })
    }

    const handleModifyChange = (e) => {
        const { name, value } = e.target;
        const idx = e.target.dataset.id;

        if (value === e.target.defaultValue) {
            return
        }

        modifyPartials({ id: idx, [name]: value })
            .then(() => {
                setTimeout(() => dispatch(updateWarehouseData(warehouse)), 100);
                fetchOrder();
            });
    };

    if (!order) {
        return <></>
    }

    return (
        <>
            <Modal className="warehouse-modal" show={modalState.showModal} onHide={closeModal}>
                <Modal.Header>
                    <Modal.Title>
                        Order: {order?.order_no} | {order?.units} units | {order?.weight} lbs
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <table className="table">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th style={{ width: '10%' }}>Quantity</th>
                                <th style={{ width: '10%' }}>Weight</th>
                                <th>date</th>
                                <th>Outbound</th>
                                <th>Trailer</th>
                                <th>Destination</th>
                                <th>Status</th>
                                <th>Delete</th>
                            </tr>
                        </thead>
                        <tbody>
                            {order.partials.concat(order.incoming_partials).map((partial, idx) => (
                                <tr key={partial.id}>
                                    <td>{idx + 1}</td>
                                    <td>
                                        <input
                                            className="input thin"
                                            name='quantity'
                                            defaultValue={partial.quantity}
                                            data-id={partial.id}
                                            onBlur={handleModifyChange}
                                            disabled={partial.outgoing_completed ? true : false}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            className="input thin"
                                            data-id={partial.id}
                                            onBlur={handleModifyChange}
                                            disabled={partial.outgoing_completed ? true : false}
                                            defaultValue={partial.weight}
                                            name='weight'
                                        />
                                    </td>
                                    <td
                                        style={{ width: '10%' }}
                                    >
                                        {partial.created_at}</td>
                                    <td>{partial.outbound}</td>
                                    <td>
                                        <input
                                            className="input thin"
                                            name='trailer'
                                            defaultValue={partial.trailer}
                                            data-id={partial.id}
                                            onBlur={handleModifyChange}
                                            disabled={partial.outgoing_completed ? true : false}
                                        />
                                    </td>
                                    <td>
                                        <select
                                            name='destination_terminal'
                                            className="input thin"
                                            data-id={partial.id}
                                            defaultValue={partial.destination_terminal?.id || ""}
                                            onChange={handleModifyChange}
                                            disabled={partial.outgoing_completed ? true : false}
                                        >
                                            <option value="" disabled hidden>
                                                ---
                                            </option>
                                            {terminals.map((option) => (
                                                <option key={option.id} value={option.id} hidden={option.id === order.terminal_object.id}>
                                                    {option.name}
                                                </option>
                                            ))}
                                        </select>
                                    </td>
                                    <td>
                                        {partial.incoming_completed
                                            ? "Received"
                                            : partial.outgoing_completed
                                                ? "In Transit"
                                                : "Not Shipped"
                                        }
                                    </td>
                                    <td>
                                        <button
                                            onClick={
                                                () => deletePartials(
                                                    {
                                                        id: partial.id,
                                                    }
                                                ).then(
                                                    () => {
                                                        setTimeout(() => {
                                                            dispatch(updateWarehouseData(warehouse))
                                                        }
                                                            , 100)
                                                        fetchOrder()
                                                    }
                                                )
                                            }
                                            disabled={partial.outgoing_completed ? true : false}
                                            className='btn btn-link p-0'
                                        >
                                            <i className='fa fa-trash' />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <td>{order.partials.length + 1}</td>
                                <td>
                                    <input
                                        className="input thin"
                                        name='quantity'
                                        onChange={handleChange}
                                    />
                                </td>
                                <td>
                                    <input
                                        className="input thin"

                                        name='weight'
                                        onChange={handleChange}
                                    />
                                </td>
                                <td>

                                </td>
                                <td>
                                    {/* <input
                                        className="input thin"

                                        name='carrier'
                                        onChange={handleChange}
                                    /> */}
                                    <select
                                        name='bus'
                                        className="input thin"
                                        defaultValue={""}
                                        onChange={handleChange}
                                        disabled={loading ? true : false}
                                    >
                                        <option value="" disabled hidden>
                                            {
                                                loading ? "Loading..." : "---"
                                            }
                                        </option>
                                        {buses.map((option) => (
                                            <option key={option.id} value={option.id}>
                                                {option.name}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                                <td>
                                    <input
                                        className="input thin"

                                        name='trailer'
                                        onChange={handleChange}
                                    />
                                </td>
                                <td>
                                    <select
                                        name='destination_terminal'
                                        className="input thin"
                                        defaultValue=""
                                        onChange={handleChange}
                                    >
                                        <option value="" disabled hidden>
                                            ---
                                        </option>
                                        {terminals.filter(terminal => terminal.name !== order.terminal_object.name).map((option) => (
                                            <option key={option.id} value={option.id}>
                                                {option.name}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={closeModal}>
                        Close
                    </Button>
                    <Button onClick={() => {
                        createPartial(
                            {
                                ...newRow,
                                order: order.id,
                                origin_terminal: order.terminal_object.id,
                            }
                        ).then(
                            () => dispatch(updateWarehouseData(warehouse))
                        ).then(
                            () => fetchOrder()
                        )
                    }} disabled={false}>
                        Add Partial
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default PartialCreator
